var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group 12427"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M16.4089 15.0996C15.0662 15.0996 13.959 16.1832 13.959 17.5496C13.959 18.8923 15.0426 19.9995 16.4089 19.9995C17.7517 19.9995 18.8589 18.9159 18.8589 17.5496C18.8354 16.2068 17.7517 15.0996 16.4089 15.0996Z",
  fill: "#00538F"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_3"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M20.72 3.41581C20.6729 3.41581 20.6022 3.39226 20.5315 3.39226H5.69042L5.45485 1.81391C5.31351 0.777392 4.41833 0 3.35825 0H1.45011C0.931844 0 0.507812 0.424032 0.507812 0.942293C0.507812 1.46055 0.931844 1.88459 1.45011 1.88459H3.35825C3.47604 1.88459 3.57026 1.97882 3.59382 2.0966L5.05438 12.0378C5.24284 13.2863 6.32647 14.2286 7.59857 14.2286H17.3984C18.6234 14.2286 19.6835 13.357 19.9426 12.1556L21.4738 4.49945C21.5681 4.00475 21.2383 3.51004 20.72 3.41581Z",
  fill: "#00538F"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_5"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_6"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M10.4028 17.4318C10.3557 16.1361 9.27207 15.0996 7.97642 15.0996C6.61009 15.1703 5.57357 16.301 5.62068 17.6438C5.6678 18.9395 6.72788 19.976 8.02353 19.976H8.07065C9.41341 19.9053 10.4735 18.7746 10.4028 17.4318Z",
  fill: "#00538F"
}))));

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.6e52f7a1.svg";
export { ForwardRef as ReactComponent };